<template>
  <section class="hero is-primary is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns">
          <div class="column is-3">
          </div>
          <div class="column is-6">
            <img src="../assets/notfound.png">
            <b-button type="is-light" @click="backbtn">Back To Previous Page</b-button>
          </div>
          <div class="column is-3">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'notfound',
  methods: {
    backbtn() {
      this.$router.push('/');
    },
  },
};
</script>
